import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';
import 'es6-promise/auto'

import Vue from 'vue'
import Vuex from 'vuex'
import VueOnsen from 'vue-onsenui';
import App from './App.vue'
import store from './store';
import EventHub from './plugins/EventHub';
import './registerServiceWorker'

import VueAnalytics from 'vue-analytics'
// import VueAdsense from 'vue-adsense'

Vue.use(Vuex);
Vue.use(VueOnsen);
Vue.use(EventHub);

Vue.use(VueAnalytics, {
    id: 'UA-136577891-1'
});
// Vue.component('adsense', VueAdsense)
Vue.config.productionTip = false;

new Vue({
    store,
    render: h => h(App)
}).$mount('#app');

// データインポートしたいときは呼ぶ
// import './firebase/admin/dataImport';
